// src/App.js
import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import AdminLayout from "./layout/AdminLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import ArtifactList from "./pages/ArtifactList";
import AddArtifact from "./pages/AddArtifact";
import ViewArtifact from "./pages/ViewArtifact";
import EditArtifact from "./pages/EditArtifact";
import QRCodePage from "./pages/QRCodePage";
import Viewers from "./pages/Viewers";
import Scanner from "./pages/Scanner";
import ArtifactInfo from "./pages/ArtifactInfo";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />

      {/* admin layout route with nested routes */}
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="artifacts" element={<ArtifactList />} />
        <Route path="artifacts/add" element={<AddArtifact />} />
        <Route path="artifacts/:id" element={<ViewArtifact />} />
        <Route path="artifacts/:id/edit" element={<EditArtifact />} />
        <Route path="qrcodes" element={<QRCodePage />} />
        <Route path="viewers" element={<Viewers />} />
        {/* default inside /admin -> redirect to artifacts */}
        <Route index element={<ArtifactList />} />
      </Route>

      <Route path="/scanner" element={<Scanner />} />
      <Route path="/info/:id" element={<ArtifactInfo />} />
    </Routes>
  );
}
